module.exports = __webpack_public_path__ + "img/EV.fd5f5c16.png";